import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as projectActions from './projectActions';


//Action Creators
export const loadFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MPROJECTLISTMAP_LOAD_FAIL,
    error
  };
};
export const loadStart = () => {
  return {
    type: actionTypes.MPROJECTLISTMAP_LOAD_START
  };
};
export const loadSuccess = (data) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_LOAD_SUCCESS,
    data
  };
};
export const loadProjectsFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MPROJECTLISTMAP_PROJECTS_LOAD_FAIL,
    error
  };
};
export const loadProjectsStart = () => {
  return {
    type: actionTypes.MPROJECTLISTMAP_PROJECTS_LOAD_START
  };
};
export const loadProjectsSuccess = (projects) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_PROJECTS_LOAD_SUCCESS,
    projects
  };
};
export const searchFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MPROJECTLISTMAP_SEARCH_FAIL,
    error
  };
};
export const searchStart = (query) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SEARCH_START,
    searchQuery: query
  };
};
export const searchSuccess = (data) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SEARCH_SUCCESS,
    data
  };
};
export const setFilters = (filters) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER,
    filters
  };
};
export const setFilterInputsActionCreator = (filterInputs) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTERINPUTS,
    filterInputs
  };
};
export const setListLength = (listLength) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_LISTLENGTH,
    listLength
  };
};
export const setFilterProgram = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROGRAM,
    filter
  };
};
export const setFilterProgramTemp = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROGRAMTEMP,
    filter
  };
};
export const setFilterProjectType = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTTYPE,
    filter
  };
};
export const setFilterProjectTypeTemp = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTTYPETEMP,
    filter
  };
};
export const setFilterProjectStatus = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTSTATUS,
    filter
  };
};
export const setFilterProjectStatusTemp = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTSTATUSTEMP,
    filter
  };
};
export const setFilterProgramSelect = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROGRAMSELECT,
    filter
  };
};
export const setFilterProgramSelectTemp = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROGRAMSELECTTEMP,
    filter
  };
};
export const setFilterProjectStatusSelect = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTSTATUSSELECT,
    filter
  };
};
export const setFilterProjectStatusSelectTemp = (filter) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_FILTER_PROJECTSTATUSSELECTTEMP,
    filter
  };
};
export const setViewMap = (viewMap) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_SET_VIEWMAP,
    viewMap
  };
};
export const toggleSearch = (isSearchOpen) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_TOGGLE_SEARCH,
    isSearchOpen
  };
};
export const toggleMobileFiltering = (isFilteringOpen) => {
  return {
    type: actionTypes.MPROJECTLISTMAP_TOGGLE_FILTERING,
    isFilteringOpen
  };
};

function listFilterParams(filters = {}) {
  const params = {
    // Sort by updatedAt, not LastSave: LastSave is a legacy migration field that
    // nothing writes, so it is null on new entries and stale on edited ones.
    // This builder feeds every /projects list fetch (MProjectListMap), which is
    // the list the Our Projects page actually renders (LLSU2-301).
    _sort: 'updatedAt:desc',
    ...apiValues.PROJECT_LIST_POPULATE,
  };
  if (filters.Program_in) params.Program_in = filters.Program_in;
  if (filters.projectstatus_in) params.projectstatus_in = filters.projectstatus_in;
  if (filters.ProjectTypes_in && filters.ProjectTypes_in.length > 0) {
    params.ProjectTypes_in = filters.ProjectTypes_in;
  }
  return params;
}

function normalizeListProjects(results) {
  return results
    ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed)
    : [];
}

/** Title search matches Title or Neighborhoods; merge once with a lean catalog fetch. */
function fetchTitleSearchCatalog(filters) {
  const base = listFilterParams(filters);
  const titlePromise = apiActions
    .loadEndpointByFilters(apiValues.nref.project.endpoint, {
      ...base,
      Title_contains: filters.Title_contains,
      _limit: apiValues.PROJECT_CATALOG_LIMIT,
    })
    .then(normalizeListProjects);
  const neighborhoodsPromise = apiActions
    .loadEndpointByFilters(apiValues.nref.project.endpoint, {
      ...base,
      Neighborhoods_contains: filters.Title_contains,
      _limit: apiValues.PROJECT_CATALOG_LIMIT,
    })
    .then(normalizeListProjects);

  return Promise.all([titlePromise, neighborhoodsPromise]).then(
    ([titleResults, neighborhoodsResults]) =>
      helpers.mergeArraysWithoutDuplicatesBasedOnProperty(
        titleResults,
        neighborhoodsResults,
        'id',
      ),
  );
}

function fetchProjectListPage(filters, start, limit) {
  return apiActions
    .loadEndpointByFilters(apiValues.nref.project.endpoint, {
      ...listFilterParams(filters),
      Title_contains: filters.Title_contains || undefined,
      _start: start,
      _limit: limit,
    })
    .then(normalizeListProjects);
}

export const filterList = (filters) => (dispatch) => {
  dispatch(setListLength(apiValues.PROJECTS_PER_PAGE));
  dispatch(setFilters(filters));
  dispatch(loadProjectsStart());
  dispatch(setFilterInputsActionCreator({
    filter_program: filters.Program_in,
    filter_program_temp: filters.Program_in,
    filter_projectStatus: filters.projectstatus_in,
    filter_projectStatus_temp: filters.projectstatus_in,
    filter_projectType: filters.ProjectTypes_in,
    filter_projectType_temp: filters.ProjectTypes_in,
    filter_title: filters.Title_contains,
    programSelect: filters.Program_in,
    projectStatusSelect: filters.projectstatus_in,
  }));

  const applyProjects = (projects, clientCatalog) => {
    dispatch(projectActions.loadProjectManySuccess(projects));
    dispatch(loadProjectsSuccess(projects.map((project) => project.id)));
    dispatch(setListLength(Math.min(apiValues.PROJECTS_PER_PAGE, projects.length)));
    dispatch({
      type: actionTypes.MPROJECTLISTMAP_SET_FILTERINPUTS,
      filterInputs: {
        hasMore: clientCatalog
          ? projects.length > apiValues.PROJECTS_PER_PAGE
          : projects.length >= apiValues.PROJECTS_PER_PAGE,
        clientCatalog: !!clientCatalog,
      },
    });
  };

  if (filters.Title_contains) {
    return fetchTitleSearchCatalog(filters).then((projects) => {
      applyProjects(projects, true);
    });
  }

  return fetchProjectListPage(filters, 0, apiValues.PROJECTS_PER_PAGE).then((projects) => {
    applyProjects(projects, false);
  });
};

export const loadMore = () => (dispatch, getState) => {
  const state = getState().mProjectListMap;
  if (state.isLoading || state.hasMore === false) return Promise.resolve();

  if (state.clientCatalog) {
    const nextLength = Math.min(
      (state.listLength || 0) + apiValues.PROJECTS_PER_PAGE,
      (state.projects || []).length,
    );
    dispatch(setListLength(nextLength));
    dispatch({
      type: actionTypes.MPROJECTLISTMAP_SET_FILTERINPUTS,
      filterInputs: {
        hasMore: nextLength < (state.projects || []).length,
      },
    });
    return Promise.resolve();
  }

  const start = (state.projects || []).length;
  dispatch(loadProjectsStart());

  const filters = {
    Program_in: state.filter_program,
    projectstatus_in: state.filter_projectStatus,
    ProjectTypes_in: state.filter_projectType,
    Title_contains: state.filter_title,
  };

  return fetchProjectListPage(filters, start, apiValues.PROJECTS_PER_PAGE)
    .then((projects) => {
      dispatch(projectActions.loadProjectManySuccess(projects));
      const ids = [...(state.projects || []), ...projects.map((project) => project.id)];
      dispatch(loadProjectsSuccess(ids));
      dispatch(setListLength(ids.length));
      dispatch({
        type: actionTypes.MPROJECTLISTMAP_SET_FILTERINPUTS,
        filterInputs: {
          hasMore: projects.length >= apiValues.PROJECTS_PER_PAGE,
          clientCatalog: false,
        },
      });
    })
    .catch((err) => dispatch(loadProjectsFail(err)));
};

export const init = (filters) => dispatch => {
  dispatch(loadStart());
  dispatch(setFilters(filters));

  let mProjectListMap = {};
  mProjectListMap.listLength = apiValues.PROJECTS_PER_PAGE;
  mProjectListMap.viewMap = filters.viewMap;
  mProjectListMap.clientCatalog = !!filters.Title_contains;
  mProjectListMap.hasMore = true;

  const projectsPromise = filters.Title_contains
    ? fetchTitleSearchCatalog(filters)
    : fetchProjectListPage(filters, 0, apiValues.PROJECTS_PER_PAGE);

  return Promise.all([
    projectsPromise,
    apiActions.loadEndpoint(apiValues.nref.program.endpoint, null, apiValues.FILTER_OPTION_QUERY),
    apiActions.loadEndpoint(apiValues.nref.projectStatus.endpoint, null, apiValues.FILTER_OPTION_QUERY),
  ]).then(([projects, programs, projectstatuses]) => {
    dispatch(projectActions.loadProjectManySuccess(projects));

    mProjectListMap.projects = projects.map(project => project.id);
    mProjectListMap.programs = apiActions.arraySelectCamelCaseKeys(programs, apiValues.FILTER_OPTION_FIELDS);
    mProjectListMap.projectStatuses = apiActions.arraySelectCamelCaseKeys(projectstatuses, apiValues.FILTER_OPTION_FIELDS);
    mProjectListMap.listLength = Math.min(apiValues.PROJECTS_PER_PAGE, projects.length);
    mProjectListMap.hasMore = filters.Title_contains
      ? projects.length > apiValues.PROJECTS_PER_PAGE
      : projects.length >= apiValues.PROJECTS_PER_PAGE;
    mProjectListMap.clientCatalog = !!filters.Title_contains;

    dispatch(setFilterInputsActionCreator({
      filter_program: filters.Program_in,
      filter_program_temp: filters.Program_in,
      filter_projectStatus: filters.projectstatus_in,
      filter_projectStatus_temp: filters.projectstatus_in,
      filter_projectType: filters.ProjectTypes_in,
      filter_projectType_temp: filters.ProjectTypes_in,
      filter_title: filters.Title_contains,
      programSelect: filters.Program_in,
      projectStatusSelect: filters.projectstatus_in
    }));

    dispatch(loadSuccess(mProjectListMap));

    return mProjectListMap;
  }).catch(err => {
    console.error(err);
    dispatch(loadFail(err));
  });
};
export const doSearch = (query) => dispatch => {
  dispatch(searchStart(query));

  if(query && query.length > 0){
    const suggest = apiValues.PROJECT_SUGGEST_QUERY;
    const titlePromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {
      Title_contains: query,
      ...suggest,
    })
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));
    const neighborhoodsPromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {
      Neighborhoods_contains: query,
      ...suggest,
    })
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));

    return Promise.all([titlePromise, neighborhoodsPromise])
      .then(([titleResults, neighborhoodsResults]) => {
        const results = {suggestedProjects: helpers.mergeArraysWithoutDuplicatesBasedOnProperty(titleResults, neighborhoodsResults, 'id')};
        dispatch(searchSuccess(results));
      });
  }
  else{
    dispatch(searchSuccess({
      suggestedProjects: undefined,
      viewProjectsNear: undefined
    }));
    return Promise.resolve();
  }
};
export const setFilterInputs = (filterInputs) => dispatch => {
  return dispatch(setFilterInputsActionCreator(filterInputs));
};
